module.exports = '/ng-templates/media-viewer/kp-media-viewer-files/kp-media-viewer-files.tpl.ftl';
